import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

export const firebaseConfig = {
  apiKey: "AIzaSyANHkAbQQYmr9RTBcy052V5Ir6BNXo0Ejo",
  authDomain: "riff-draft.firebaseapp.com",
  projectId: "riff-draft",
  storageBucket: "riff-draft.firebasestorage.app",
  messagingSenderId: "689480292650",
  appId: "1:689480292650:web:a0f34e4d038eaaf40d2653",
  measurementId: "G-7VQ5X999WY",
};

// VAPID public key for FCM Web Push. Safe to expose publicly — it's embedded
// in the service worker anyway. Generated in Firebase Console → Project Settings
// → Cloud Messaging → Web Push certificates.
export const FCM_VAPID_KEY = "BBZTF8KhWh9ikXWDpv7LYP6wYv-TKnFs03PzCQ26lU4LunfO9grdTlCj6NQzvYrHVl5gqV2I34GHMva5YSchX1s";

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export default { auth, app };
